import React, { useState } from 'react';
import './BlogPage.css';
import defaultImage from '../assets/profile.jpg';
import dockerImage from '../assets/1.webp';
import reactRouterImage from '../assets/2.png';
import firebaseImage from '../assets/3.png';
import nodejsStreamImage from '../assets/4.png';
import pythonApiImage from '../assets/5.png';
import reactHooksImage from '../assets/6.png';
import mysqlImage from '../assets/7.png';
import socketIoImage from '../assets/8.png';
import crossPlatformImage from '../assets/9.png';
import kafkaImage from '../assets/10.png';
import githubActionsImage from '../assets/11.png';
import scalableNodeImage from '../assets/12.png';
import reactScalableImage from '../assets/13.png';



const BlogPage = () => {

    const allBlogs = [
        {
            title: 'Introduction to Docker: Why Containers are the Future',
            date: 'January 23, 2025',
            author: 'Amit Kumar',
            excerpt: 'Docker has revolutionized the way applications are deployed and managed. Learn the basics of Docker and how it simplifies development.',
            content: `
                Docker is a platform that uses OS-level virtualization to deliver software in packages called containers. Containers are lightweight, portable, and include everything needed to run your application. In this blog, we’ll explore how Docker works, why it’s popular, and how you can set up your first containerized application.
            `,
            image: dockerImage,
        },
        {
            title: 'Mastering React Router: Navigating Single Page Applications',
            date: 'January 20, 2025',
            author: 'Amit Kumar',
            excerpt: 'React Router is the go-to library for handling navigation in React apps. This blog dives into its features and implementation.',
            content: `
                React Router enables developers to build dynamic, client-side routing in React applications. With React Router, you can define routes for your app, render components based on the URL, and create dynamic user experiences. This blog will guide you through setting up React Router and using its advanced features like nested routing and programmatic navigation.
            `,
            image: reactRouterImage,
        },
        {
            title: 'Firebase Authentication: Secure Your App with Ease',
            date: 'January 15, 2025',
            author: 'Amit Kumar',
            excerpt: 'Firebase Authentication simplifies the process of adding login functionality to your apps. Learn how to integrate it step-by-step.',
            content: `
                Firebase Authentication provides backend services, easy-to-use SDKs, and ready-made UI libraries to authenticate users. It supports multiple sign-in methods, including email, Google, Facebook, and more. This blog will walk you through setting up Firebase Authentication in your project and customizing the user experience.
            `,
            image: firebaseImage,
        },
        {
            title: 'Node.js Streams: Processing Data Like a Pro',
            date: 'January 13, 2025',
            author: 'Amit Kumar',
            excerpt: 'Streams in Node.js allow you to handle large amounts of data efficiently. This blog explains how to use streams in your projects.',
            content: `
                Streams are one of the most powerful features of Node.js, enabling you to process data piece-by-piece without keeping it all in memory. This makes streams ideal for handling large files or real-time data. We’ll cover the four types of streams in Node.js: Readable, Writable, Duplex, and Transform, along with practical examples.
            `,
            image: nodejsStreamImage,
        },
        {
            title: 'Building APIs with Flask: A Step-by-Step Guide',
            date: 'January 7, 2025',
            author: 'Amit Kumar',
            excerpt: 'Flask is a lightweight Python web framework perfect for building APIs. Learn how to create and deploy a simple RESTful API.',
            content: `
                Flask is a micro-framework for Python that allows you to build web applications quickly and efficiently. Its minimalistic approach makes it a great choice for creating APIs. In this blog, we’ll create a RESTful API from scratch, covering routing, request handling, and error management.
            `,
            image: pythonApiImage,
        },
        {
            title: 'Understanding React Hooks: Simplify Your Functional Components',
            date: 'December 24, 2024',
            author: 'Amit Kumar',
            excerpt: 'React Hooks revolutionize how we work with state and lifecycle in functional components. Dive deep into useState and useEffect.',
            content: `
                React Hooks are special functions that let you use state and other React features in functional components. This blog focuses on the two most commonly used hooks, useState and useEffect, with practical examples and best practices to make your code cleaner and more maintainable.
            `,
            image: reactHooksImage,
        },
        {
            title: 'MySQL vs. MongoDB: Choosing the Right Database',
            date: 'December 24, 2024',
            author: 'Amit Kumar',
            excerpt: 'MySQL and MongoDB are two of the most popular databases. Understand their differences and choose the best one for your project.',
            content: `
                MySQL is a relational database that uses structured schemas, while MongoDB is a NoSQL database designed for flexibility and scalability. This blog compares their use cases, performance, and features, helping you decide which is the right fit for your application.
            `,
            image: mysqlImage,
        },
        {
            title: 'Socket.IO: Real-Time Communication Made Simple',
            date: 'December 22, 2024',
            author: 'Amit Kumar',
            excerpt: 'Socket.IO enables real-time communication in web applications. Learn how to set up a chat app with Node.js and Socket.IO.',
            content: `
                Real-time communication is essential for modern web applications like chat apps, live notifications, and online games. Socket.IO is a JavaScript library that simplifies implementing WebSocket connections. In this blog, we’ll build a basic chat application to demonstrate its power.
            `,
            image: socketIoImage,
        },
        {
            title: 'Git Best Practices: Commit Like a Pro',
            date: 'December 21, 2024',
            author: 'Amit Kumar',
            excerpt: 'Writing good commit messages is crucial for team collaboration. Learn how to structure your Git commits for clarity and efficiency.',
            content: `
                Git commit messages are an important part of project history. Well-written commit messages make it easier to understand changes and collaborate with teams. This blog covers tips for writing clear commit messages, including best practices for structuring them and using meaningful descriptions.
            `,
            image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=400',
        },
        {
            title: 'BigQuery for Beginners: Analyzing Data at Scale',
            date: 'December 8, 2024',
            author: 'Amit Kumar',
            excerpt: 'BigQuery is Google’s powerful data warehouse. Learn how to analyze large datasets efficiently using SQL queries.',
            content: `
                BigQuery is a fully managed, serverless data warehouse by Google Cloud. It allows you to run fast SQL queries on massive datasets without managing infrastructure. In this blog, we’ll explore its key features and provide a hands-on tutorial for beginners.
            `,
            image: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=400',
        },
        {
            title: 'React Native: Building Cross-Platform Mobile Apps',
            date: 'December 8, 2024',
            author: 'Amit Kumar',
            excerpt: 'React Native allows you to build mobile apps using JavaScript and React. Learn how to create cross-platform apps with ease.',
            content: `
                React Native is a popular framework for building mobile applications using JavaScript and React. It allows you to write code once and deploy it on both iOS and Android platforms. This blog will guide you through setting up a React Native project and building your first cross-platform app.
            `,
            image: crossPlatformImage,
        },
        {
            title: 'Kafka: Building Real-Time Data Pipelines',
            date: 'December 3, 2024',
            author: 'Amit Kumar',
            excerpt: 'Apache Kafka is a distributed streaming platform. Learn how to build real-time data pipelines and stream processing applications.',
            content: `
                Apache Kafka is a distributed streaming platform that allows you to build real-time data pipelines and stream processing applications. It is designed to handle large volumes of data with low latency. In this blog, we’ll cover the basics of Kafka, its architecture, and how to set up a Kafka cluster.
            `,
            image: kafkaImage,
        },
        {
            title: 'Introduction to GitHub Actions: Automate Your Workflow',
            date: 'November 23, 2024',
            author: 'Amit Kumar',
            excerpt: 'GitHub Actions allows you to automate your development workflow. Learn how to set up CI/CD pipelines with ease.',
            content: `
                GitHub Actions is a powerful tool for automating your development workflow. It allows you to create custom CI/CD pipelines, automate testing, and deploy your applications. This blog will guide you through setting up GitHub Actions for your project and creating your first workflow.
            `,
            image: githubActionsImage,
        },
        {
            title: 'Building Scalable Applications with Node.js',
            date: 'October 18, 2024',
            author: 'Amit Kumar',
            excerpt: 'Node.js is a powerful platform for building scalable applications. Learn best practices for scaling your Node.js applications.',
            content: `
                Node.js is a powerful platform for building scalable and efficient web applications. In this blog, we will discuss best practices for building scalable Node.js applications, including code organization, performance optimization, and more.
            `,
            image: scalableNodeImage,
        },
        {
            title: 'React Performance Optimization: Tips and Tricks',
            date: 'October 18, 2024',
            author: 'Amit Kumar',
            excerpt: 'Optimizing the performance of your React applications is crucial. Learn tips and tricks to make your React apps faster.',
            content: `
                Performance optimization is crucial for providing a good user experience in React applications. This blog covers tips and tricks for optimizing the performance of your React apps, including code splitting, lazy loading, and memoization.
            `,
            image: reactScalableImage,
        },
        // {
        //     title: 'Python for Data Science: Getting Started',
        //     date: 'January 8, 2025',
        //     author: 'Amit Kumar',
        //     excerpt: 'Python is a popular language for data science. Learn how to get started with Python for data analysis and visualization.',
        //     content: `
        //         Python is a popular language for data science due to its simplicity and powerful libraries. This blog will guide you through getting started with Python for data analysis and visualization, covering libraries like Pandas, NumPy, and Matplotlib.
        //     `,
        //     image: 'https://images.unsplash.com/photo-1517430816045-df4b7de01f17?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=400',
        // },
        // {
        //     title: 'Building RESTful APIs with Flask',
        //     date: 'January 7, 2025',
        //     author: 'Amit Kumar',
        //     excerpt: 'Flask is a lightweight Python web framework perfect for building APIs. Learn how to create and deploy a simple RESTful API.',
        //     content: `
        //         Flask is a micro-framework for Python that allows you to build web applications quickly and efficiently. Its minimalistic approach makes it a great choice for creating APIs. In this blog, we’ll create a RESTful API from scratch, covering routing, request handling, and error management.
        //     `,
        //     image: 'https://images.unsplash.com/photo-1517430816045-df4b7de01f17?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=400',
        // },
        // {
        //     title: 'Firebase Firestore: Real-Time Database for Your Apps',
        //     date: 'January 6, 2025',
        //     author: 'Amit Kumar',
        //     excerpt: 'Firestore is a flexible, scalable database for mobile, web, and server development. Learn how to integrate Firestore into your apps.',
        //     content: `
        //         Firebase Firestore is a flexible, scalable database for mobile, web, and server development. It provides real-time data synchronization and offline support. This blog will guide you through integrating Firestore into your applications and using its powerful features.
        //     `,
        //     image: 'https://images.unsplash.com/photo-1517430816045-df4b7de01f17?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=400',
        // },
        // {
        //     title: 'Introduction to BigQuery: Analyzing Data at Scale',
        //     date: 'January 5, 2025',
        //     author: 'Amit Kumar',
        //     excerpt: 'BigQuery is Google’s powerful data warehouse. Learn how to analyze large datasets efficiently using SQL queries.',
        //     content: `
        //         BigQuery is a fully managed, serverless data warehouse by Google Cloud. It allows you to run fast SQL queries on massive datasets without managing infrastructure. In this blog, we’ll explore its key features and provide a hands-on tutorial for beginners.
        //     `,
        //     image: 'https://images.unsplash.com/photo-1517430816045-df4b7de01f17?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=400',
        // },
        
        
        
    ];



    const [visibleBlogs, setVisibleBlogs] = useState(10);
    const [selectedBlog, setSelectedBlog] = useState(null);

    const handleViewMore = () => {
        setVisibleBlogs((prevVisibleBlogs) => prevVisibleBlogs + 10);
    };

    const handleReadMore = (blog) => {
        setSelectedBlog(blog);
    };

    const handleCloseModal = () => {
        setSelectedBlog(null);
    };

    return (
        <div className="blog-page">
            <h1 className="blog-title">Tech Blogs</h1>
            <p className="blog-subtitle">Stay ahead with the latest in technology and innovation</p>

            <div className="blog-grid">
                {allBlogs.slice(0, visibleBlogs).map((blog, index) => (
                    <div key={index} className="blog-card">
                        <img src={blog.image || defaultImage} alt={blog.title} className="blog-image" />
                        <div className="blog-content">
                            <h2 className="blog-heading">{blog.title}</h2>
                            <p className="blog-author">By {blog.author} on {blog.date}</p>
                            <p className="blog-excerpt">{blog.excerpt}</p>
                            <button className="read-more" onClick={() => handleReadMore(blog)}>Read More</button>
                        </div>
                    </div>
                ))}
            </div>

            {visibleBlogs < allBlogs.length && (
                <button className="view-more" onClick={handleViewMore}>View More</button>
            )}

            {selectedBlog && (
                <div className="modal">
                    <div className="modal-content">
                        <span className="close" onClick={handleCloseModal}>&times;</span>
                        <h2>{selectedBlog.title}</h2>
                        <p className="blog-author">By {selectedBlog.author} on {selectedBlog.date}</p>
                        <img src={selectedBlog.image || defaultImage} alt={selectedBlog.title} className="modal-image" />
                        <p>{selectedBlog.content}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BlogPage;